import { render } from "./Header.vue?vue&type=template&id=4ada30b0&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=4ada30b0&scoped=true&lang=scss"
import "./Header.vue?vue&type=style&index=1&id=4ada30b0&scoped=true&lang=scss"
import "./Header.vue?vue&type=style&index=2&id=4ada30b0&scoped=true&lang=scss"
import "./Header.vue?vue&type=style&index=3&id=4ada30b0&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ada30b0"]])

export default __exports__